import type { Staff } from "@/lib/authv2/store";
import { opsRole } from "@/lib/auth/page-access";

// branch_manager: điều hành tiệm — máy chủ cấp customer_booking.manage
// (actions.go:127), nên vào tập nhận diện này là đúng.
//
// coordinator (Điều Phối) ĐÃ RA KHỎI TẬP 23/08/2026 theo quyết định 0050:
// máy chủ rút sạch quyền của vai này, giữ lại đây là bày ra nút sửa/huỷ đặt
// lịch rồi ăn 403 — đúng kiểu lỗi mà khối chú thích dưới đây cảnh báo.
//
// QC CỐ Ý KHÔNG có mặt: máy chủ chỉ cấp QC `customer_booking.read`, KHÔNG
// cấp `.manage`. Tập này được OR vào CẢ canRead LẪN canManage
// (BookingTab.tsx:101-102), nên thêm QC vào đây sẽ bày ra nút sửa/huỷ mà
// máy chủ trả 403. QC đọc được rồi — qua nhánh quyền customer_booking.read,
// có ở cả ba nơi dùng. (spec 2026-08-23 §5.6)
const CUSTOMER_BOOKING_ROLES = new Set([
  "admin",
  "director",
  "manager",
  "sale",
  "branch_manager",
]);

function normalize(value: string | null | undefined): string {
  return (value ?? "").toLowerCase().trim();
}

export function canAccessCustomerBookingByIdentity(
  staff: (Pick<Staff, "role" | "department"> & { jobTitleCode?: string | null }) | null | undefined,
): boolean {
  if (!staff) return false;
  // Trưởng ca mang `customer_booking.manage` như Trưởng cửa hàng (QĐ 0425).
  return (
    normalize(staff.department) === "cskh" || CUSTOMER_BOOKING_ROLES.has(normalize(opsRole(staff)))
  );
}
